import { render } from "./DataVariantManage.vue?vue&type=template&id=515c82bd"
import script from "./DataVariantManage.vue?vue&type=script&lang=js"
export * from "./DataVariantManage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Pages/DataVariantManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "515c82bd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('515c82bd', __exports__)) {
    console.log('reload')
    api.reload('515c82bd', __exports__)
  }
  
  module.hot.accept("./DataVariantManage.vue?vue&type=template&id=515c82bd", () => {
    console.log('re-render')
    api.rerender('515c82bd', render)
  })

}


export default __exports__